window.SP = window.SP || {};
SP.promptConfig = SP.promptConfig || {};


SP.promptConfig = Object.assign( {
    endpoint: "https://admin.magazineadvantage.com/api/newsletter-signup",
    id: "promptEmail",
    site: "Magazine Advantage",
    logo: "https://cdn.shopify.com/s/files/1/0403/5805/2004/files/Magazine-Advantage-Logo_360x.png?v=1591121366",
    sideImage: "https://www.magazineadvantage.com/images/mag-bg.jpg",
    style: {btnBg: "#307e9a"},
    campaign: "rf-web-coupon-modal",
    launchSec: 8,
    promptedCookie: "prompted"
}, SP.promptConfig);

SP.prompt = {};

SP.prompt.display = function () {


    var display = function(){
        if( SP.stopPrompt ) {
            // do nothing, prompt was stopped
        } else {
            SP.prompt.injectStyle();
            SP.prompt.triggerPrompt();
        }
    };


    if (SP.promptConfig.launchSec) {
        setTimeout(display, SP.promptConfig.launchSec * 1000);
    } else {
        display();
    }

};


SP.prompt.injectStyle = function(){
    // create/inject styles
    var style = document.createElement('style');
    style.innerHTML =
        '.prompt-modal-outer{ position: fixed; left: 0; top: 0; right: 0; bottom: 0; background-color: rgba(0,0,0,0.4); z-index: 500}' +
        '.prompt-modal{ background-color: #fff; position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); padding: 0 0 20px 0;}' +
        '.prompt-close{ cursor: pointer; }' +
        '.prompt-logo{ max-width: 240px; width: 240px; height: auto; display: block; margin: 0 auto; margin-bottom: 0;}' +
        '.prompt-btn{ background-color: ' + SP.promptConfig.style.btnBg + '; color: #fff; font-weight: bold; min-width: 240px; display: block; margin: 10px auto; height: 40px; line-height: 40px; text-align: center; cursor: pointer;}' +
        'a.prompt-btn:not([disabled]):hover, a.prompt-btn:focus{ color: #fff; }' +
        '.prompt-btn-alt{ background-color: #eee; color: #888; font-weight: normal;}' +
        '.prompt-btn-alt:hover{ background-color: #ddd; color: #555;}' +
        '.prompt-field{ display: block; min-width: 240px; border: 1px solid #333; height: 40px; line-height: 40px; font-size: 18px; color: #111; margin-top: 25px; max-width: 320px; width: 100%;}' +
        '.prompt-field::placeholder{ color: #888 }' +
        'input.prompt-field[name=email]{ padding-left: 40px; background-repeat: no-repeat; background-size: 20px 15px; background-position-x: 10px; background-position-y: center; ' +
        '       background-image: url("data:image/png;base64;,iVBORw0KGgoAAAANSUhEUgAAABQAAAAPCAMAAADTRh9nAAAAZlBMVEWttb2vt7+ttb2ttb0AAADR1dqxucC3vsW+xcuwuMCxucCzusLIzdP4+fr29/jR1dnz9fa7wcjn6uzN0da2vcTx8vTu8PLc3+O/xcu5v8ayucHU2NzDyM7q7O7d4OPHzNGzusKttb2TNHDgAAAADXRSTlP5E4FGAASARCrgwJMLt4TFeQAAAIFJREFUGNN1jtkSwiAMAINCWy+C3KX1+v+fNODgmM64T7Awm4Cchh1jGCWcDw9kOJhAgLlwrnuSkTs9V+ntrwv5VeVSkv466137aejQbSqJmm1QWHNoOTdT6iPphjUc80pvXRL34vCJrdIlERe0fc9/y980w/gR1Ak2HAVIJTYo+Qaqig09qG+G9wAAAABJRU5ErkJggg=="); }' +
        'div.prompt-close{ position: absolute; right: 0; top: 0; font-weight: light; font-size: 40px; padding: 0 20px}' +
        '.prompt-welcome{ font-size: 14px; text-align: center; }' +
        '.prompt-h2{ font-size: 32px; text-align: center; margin: 0; max-width: 320px;}' +
        '.prompt-h2 span { font-size: 14px; vertical-align: top; display: inline-block; margin-top: 5px;}' +
        '.prompt-h3{ font-size: 20px; text-align: center; margin: 20px 0;}' +
        'div.prompt-row{ display: flex; flex-direction: row; justify-content: flex-start;}' +
        'div.prompt-content{ padding: 40px 40px 0 40px }' +
        'p.terms{ font-size: 10px; margin-bottom: 10px; text-align: center}' +
        '@media( max-width: 750px ){ .prompt-side-image{ display: none; } }';
    '@media( max-width: 500px ){ .prompt-modal{ padding: 40px; } .prompt-h3 br{ display: none; } }';
    ;

    // Get the first script tag
    var ref = document.querySelector('script');

    // Insert our new styles before the first script tag
    ref.parentNode.insertBefore(style, ref);
};

SP.prompt.triggerPrompt = function() {

    var modalMarkup = document.createElement("div");
    modalMarkup.setAttribute("id", SP.promptConfig.id);
    modalMarkup.setAttribute("class", "prompt-modal-outer");
    modalMarkup.innerHTML =
        '<div class="prompt-modal">' +
        '<div class="prompt-close">&times</div>' +
        '<div class="prompt-row">' +
        '<div class="prompt-content">' +
        '<img class="prompt-logo" src="' + SP.promptConfig.logo + '"/>' +
        '<div class="prompt-h3">Enter your Email to Receive <br/>Exclusive Offers, New Titles &amp; More!</div>' +
        '<input type="text" name="email" class="prompt-field" placeholder="Email address"/>' +
        '<a href="#" class="prompt-btn prompt-btn-submit">Keep Me Updated</a>' +
        '<a href="#" class="prompt-btn prompt-btn-alt prompt-close">No Thanks</a>' +
    '</div>' +
    '</div>' +
    '</div>';
    document.getElementsByTagName('body')[0].appendChild( modalMarkup );


    var modal = document.getElementById(SP.promptConfig.id);
    var closers = modal.getElementsByClassName("prompt-close");

    var handleClose = function(e){
        modal.parentNode.removeChild( modal );
        return false;
    };

    for( var i = 0; i < closers.length; i++){
        closers[i].addEventListener('click', handleClose);
    }



    var btnClicked = false;

    var handleSubmit = function(e){

        if (btnClicked) {
            return;
        }

        var email = modal.querySelector("input[name=email]").value;
        if( email.length == 0 ){
            alert("Please enter an email address to receive updates!");
        } else if( email.indexOf("@") == -1 ){
            alert("\"" + email + "\" is not a valid email address.\n\nPlease check your email and submit again.");
        } else {
            btnClicked = true;
            fetch(SP.promptConfig.endpoint, {
                method: 'POST',
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    "action": "submit",
                    "email": email,
                    "url": window.location.href,
                    "campaign": SP.promptConfig.campaign || null,
                    "affiliate": SP.promptConfig.affiliateId || null,
					"domain": window.location.hostname
                })
            })
                .then( function(resp){return resp.json();} )
                .then( function(data){

                    btnClicked = false;

                    if( data.success == false ){
                        alert( data.error );
                        return;
                    }
					
					handleClose();
                });
        }


        return false;
    };

    modal.getElementsByClassName("prompt-btn-submit")[0].addEventListener("click", handleSubmit);
    modal.querySelector("input[name=email]").addEventListener("keyup", function(e){
        if( e.key == "Enter" ){
            handleSubmit();
        }
    });
};
